import { BodyText, withStyles } from 'vopay';
import { useTranslation } from 'react-i18next';
import type { UserRoles } from 'vopay';
import styleSheet from './SuperAdmins.module.scss';

const cn = withStyles(styleSheet);

interface SuperAdminDetailsProps {
  superAdmins: UserRoles[];
}

const SuperAdminDetails = ({ superAdmins }: SuperAdminDetailsProps) => {
  const { t } = useTranslation('translations', {
    keyPrefix: 'TransactionApproval.Configuration.Roles.SuperAdmin.Details',
  });

  if (superAdmins.length === 0) {
    return (
      <BodyText className={cn('emptyState')}>
        {t('noAdminsMessage', { defaultValue: 'No super admins have been assigned.' })}
      </BodyText>
    );
  }

  return (
    <div className={cn('grid')}>
      {superAdmins.map((userRole) => (
        <div key={userRole.Username} className={cn('adminItem')}>
          {userRole.Username}
        </div>
      ))}
    </div>
  );
};

export default SuperAdminDetails;
